const PRODUCTIONS = 'productions';
const PRODUCTION_DETAILS = 'production_details';
const PRODUCTION_SEARCH_LIST = 'productions_search_list';
const INTRO = 'intro';
const PRO = 'pro';
const PROARTIST = 'proartist';
const PROAGENT = 'proagent';
const CONTACT = 'contact';
const ARTIST = 'artists';
const ARTIST_SEARCH_LIST = 'artists_search_list';
const ARTIST_BY_VOICE = 'artists_by_voice';
const ARTIST_BY_PROFESSION = 'artists_by_profession';
const ARTIST_DETAILS = 'artist_details';
const ARTIST_BIOGRAPHY = 'artist_biography';
const ARTIST_REPERTORIE = 'artist_repertoire';
const ARTIST_PHOTOS = 'artist_photos';
const ARTIST_VIDEOS = 'artist_videos';
const ARTIST_REVIEWS = 'artist_reviews';
const MANAGERS = 'managers';
const MANAGERS_SEARCH_LIST = 'managers_search_list';
const MANAGERS_BY_COUNTRY = 'managers_by_country';
const MANAGER_DETAILS = 'manager_details';
const COMPANIES = 'companies';
const COMPANIES_SEARCH_LIST = 'companies_search_list';
const COMPANIES_BY_COUNTRY = 'companies_by_country';
const COMPANY_DETAILS = 'company_details';
const COMPETITIONS = 'competitions';
const COMPETITIONS_SEARCH_LIST = 'competitions_search_list';
const COMPETITIONS_BY_COUNTRY = 'competitions_by_country';
const COMPETITION_DETAILS = 'competition_details';
const CASTING = 'casting';
const VENUES = 'venues';
const VENUES_SEARCH_LIST = 'venues_search_list';
const VENUES_BY_COUNTRY = 'venues_by_country';
const VENUE_DETAILS = 'venue_details';
const STATISTICS = 'statistics';
const ON_THESE_DAYS = 'on_these_days';
const MUSICAL_WORK = 'musical_works';
const MUSICAL_WORK_SEARCH_LIST = 'musical_works_search_list';
const MUSICAL_WORK_DETAILS = 'musical_work_details';
const COMPOSERS = 'composers';
const COMPOSERS_SEARCH_LIST = 'composer_search_list';
const COMPOSER_DETAILS = 'composer_details';
const ARTICLE = 'article';
const SEASONS = 'seasons';
const SEASONS_BY_COUNTRY = 'seasons_by_countries';
const SEASONS_BY_YEAR = 'seasons_by_year';
const SEASONS_DETAILS = 'season_details';
const FESTIVALS = 'festivals';
const FESTIVALS_BY_COUNTRY = 'festivals_by_countries';
const FESTIVALS_BY_YEAR = 'festivals_by_year';
const FESTIVAL_DETAILS = 'festival_details';
const MAPS = 'maps';
const RENTALS = 'rentals';
const RENTALS_SEARCH_LIST = 'rentals_search_list';
const RENTAL_DETAILS = 'rental_details';
const SETTINGS = 'settings';
const LOGIN = 'login';
const HOME = 'home';
const HIGHLIGHTS = 'highlights';

module.exports = {
  PRODUCTIONS,
  PRODUCTION_DETAILS,
  PRODUCTION_SEARCH_LIST,
  INTRO,
  PRO,
  PROARTIST,
  PROAGENT,
  CONTACT,
  ARTIST,
  ARTIST_SEARCH_LIST,
  ARTIST_BY_VOICE,
  ARTIST_BY_PROFESSION,
  ARTIST_DETAILS,
  ARTIST_BIOGRAPHY,
  ARTIST_REPERTORIE,
  ARTIST_PHOTOS,
  ARTIST_VIDEOS,
  ARTIST_REVIEWS,
  MANAGERS,
  MANAGERS_SEARCH_LIST,
  MANAGERS_BY_COUNTRY,
  MANAGER_DETAILS,
  COMPANIES,
  COMPANIES_SEARCH_LIST,
  COMPANIES_BY_COUNTRY,
  COMPANY_DETAILS,
  COMPETITIONS,
  COMPETITIONS_SEARCH_LIST,
  COMPETITIONS_BY_COUNTRY,
  COMPETITION_DETAILS,
  CASTING,
  VENUES,
  VENUES_SEARCH_LIST,
  VENUES_BY_COUNTRY,
  VENUE_DETAILS,
  STATISTICS,
  ON_THESE_DAYS,
  MUSICAL_WORK,
  MUSICAL_WORK_SEARCH_LIST,
  MUSICAL_WORK_DETAILS,
  COMPOSERS,
  COMPOSERS_SEARCH_LIST,
  COMPOSER_DETAILS,
  ARTICLE,
  SEASONS,
  SEASONS_BY_COUNTRY,
  SEASONS_BY_YEAR,
  SEASONS_DETAILS,
  FESTIVALS,
  FESTIVALS_BY_COUNTRY,
  FESTIVALS_BY_YEAR,
  FESTIVAL_DETAILS,
  MAPS,
  RENTALS,
  RENTALS_SEARCH_LIST,
  RENTAL_DETAILS,
  SETTINGS,
  LOGIN,
  HOME,
  HIGHLIGHTS,
};
